
import { Component, Vue } from "vue-property-decorator";
import { objAny } from "@/common/common-interface";
import {
  addBackstageSimReceive,
  downloadTmp,
  importSimBackstage
} from "@/api/api-basic";
import { optionKey, getOptionList } from "@/api/api-dict";
import regular from "@/common/regular";
import uploadImage from "@/components/upload-image/upload-image.vue";
import i18n from "@/config/i18n";
@Component({
  components: {
    "upload-image": uploadImage
  }
})
export default class SimApply extends Vue {
  private formInline: objAny = {
    applicant: "",
    iccid: "",
    outgoer: "",
    simSum: ""
  };
  private priorityList: object[] = [];
  private formObj: objAny = {};
  private ruleInline: objAny = {
    applicant: [
      {
        required: true,
        message: i18n.t("simOutTest.applicantPl"),
        trigger: "blur"
      }
    ],
    iccid: [
      {
        required: true,
        message: i18n.t("simOutTest.iccidPl"),
        trigger: "blur"
      }
    ],
    outgoer: [
      {
        required: true,
        message: i18n.t("simOutTest.outgoerPl"),
        trigger: "blur"
      }
    ],
    simSum: [
      { required: true, validator: regular.int, max: 999999, trigger: "blur" }
    ]
  };
  private itemData: objAny = {};
  private modalShow = false;
  private loading = false;
  public open(item: objAny) {
    this.modalShow = true;
    this.itemData = item;
  }
  public handleSubmit() {
    this.formObj.validate((valid: boolean) => {
      if (valid) {
        this.submitData();
      }
    });
  }
  async submitData(): Promise<void> {
    this.loading = true;
    const ret = await addBackstageSimReceive(this.formInline);
    if (ret.status === this.$config.apiStatus) {
      this.$Message.success(i18n.t("simOutTest.addSuccess"));
      this.$emit("success");
      this.modalShow = false;
      this.formInline.applicant = "";
      this.formInline.iccid = "";
      this.formInline.outgoer = "";
      this.formInline.simNumber = "";
      this.formInline.simSum = "";
    }
    this.loading = false;
  }
  public handleReset() {
    this.formObj.resetFields();
  }
  async getOptionList() {
    const data = await getOptionList([optionKey.priority]);
    this.priorityList = data[optionKey.priority];
  }
  async downloadTmp() {
    const ret = await downloadTmp({ businessType: 10 });
    if (ret.status === this.$config.apiStatus) {
      const url = this.$config.fileImg + ret.data[0];
      window.open(url);
    }
  }
  async importSimBackstage(file: File) {
    const ret = await importSimBackstage({ file: file });
    if (ret.status === this.$config.apiStatus) {
      console.log("success");
      const data = ret.correctList;
      const correctList = data.correctList;
      this.formInline.iccid = correctList.join(",");
      this.formInline.simSum = correctList.length;
    }
  }
  public iccidBlur() {
    const len: number = this.formInline.iccid.split(",").length;
    this.formInline.simSum = len;
  }
  mounted() {
    this.getOptionList();
    this.$nextTick(() => {
      this.formObj = this.$refs["formValidate"];
    });
  }
}
